/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Cancel_Schedule_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel scheduled storage change?" |
*
* @param {Partner_Manage_Storage_Cancel_Schedule_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_cancel_schedule_title = /** @type {((inputs?: Partner_Manage_Storage_Cancel_Schedule_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Cancel_Schedule_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Speicheränderung abbrechen?")
	return /** @type {LocalizedString} */ ("Cancel scheduled storage change?")
});